module.exports = __webpack_public_path__ + "media/icons/okres-waznosci@2x-f045663b.png";